export default __webpack_public_path__ + "static/atividade-fisica-074d07b3ee9aa02ca620a93a4320ccc5.png";